const dashboard = {
  dashboard: {
    title: 'Panel',
    switchToClassic: 'Cambiar a la vista clásica',
    comingSoon: 'Próximamente',
    companyScoreCard: 'Cuadro de rendimiento de la compañía',
    enphaseSince: 'Instalando Enphase desde',
    sitesCommissioned: 'Sitios encomendados',
    microinverters: 'Microinversores instalados',
    batteriesInstalled: 'Baterías instaladas',
    nps: 'Índice Neto de Promotores',
    ensembleCertified: 'Empresa de instalación de almacenamiento autorizada',
    einLearn: 'Más información acerca de EIN',
    yes: 'Sí',
    no: 'No',
    lastMonth: {
      one: 'en el último mes',
      other: 'en los últimos %{count} meses'
    },
    congratulations: '¡Felicidades!',
    acceptInvitation: 'Aceptar invitación',
    einInvitation: 'Has recibido una invitación para ser parte de la Red de Instaladores de Enphase',
    leadsInvitation: 'Has recibido una invitación para ser parte del Programa de Clientes Potenciales de Enphase',
    announcements: 'Anuncios',
    systems: 'Sistemas',
    all: 'Todo',
    alerts: 'Alertas',
    activations: 'Activaciones',
    leads: 'Clientes potenciales',
    search: 'Buscar',
    noResult: 'No se encontraron resultados',
    viewActivations: 'Visualizar todas las activaciones',
    viewLeads: 'Visualizar todos los clientes potenciales',
    viewSystems: 'Visualizar todos los sistemas',
    addNewSystems: 'Añadir nuevo sistema',
    total: 'Total',
    activatedSites: 'Sitios activados',
    nameId: 'Nombre / Id',
    status: 'Condición',
    city: 'Ciudad',
    state: 'Estado / Provincia',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'No disponible',
    quickAccess: 'Acceso rápido',
    contactUs: 'Contacto',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Atajos del servicio',
    newsletter: 'Boletín del instalador',
    service: 'Gerente de servicios',
    enphaseleads: 'Programa de Clientes Potenciales de Enphase',
    enphaseCommunity: 'Comunidad Enphase',
    enphaseStore: 'Tienda de Enphase',
    systemConfigurator: 'Configurador del sistema',
    criticalUpdates: 'Actualizaciones críticas',
    documentation: 'Documentación',
    brandLibrary: 'Biblioteca de la marca',
    training: 'Capacitación',
    newsBoard: 'Tablero de noticias',
    noContentAvailable: 'Sin contenido disponible',
    viewEinDashboard: 'Visualizar Panel de EIN',
    enterComments: 'Introduzca sus comentarios',
    maxAllowedComment: 'Se permiten %{maxCount} caracteres como máximo',
    switchingBackNote:
      '¿Volver a la versión clásica del Gestor de Enlighten? Ayúdenos a mejorar la nueva versión compartiendo su motivo para volver a la versión clásica',
    switchBackTitle: 'Cambiar a la vista clásica por tiempo limitado',
    new: 'Nuevo',
    view: 'Ver',
    gridProfileToken: 'Token de cambio de perfil de red',
    ProfileTokenText: 'Token de cambio de perfil',
    validText: 'Este token es válido para Envoy %{serialNumber} durante un día.',
    envoySerialNumber: 'Número de serie de Envoy',
    authorizationNumber: 'Número de autorización',
    getToken: 'Obtener Token',
    viewAll: 'Ver todo',
    viewFullList: 'Ver lista completa',
    serviceRequests: 'Solicitudes de servicio',
    inProgressRequests: 'En curso',
    totalCases: 'Total de casos',
    resolvedRequests: 'Resuelto',
    viewDetails: 'Ver detalles'
  }
};

export default dashboard;
